<template>
	<multiselect
		placeholder="Select Product"
		label="name"
		track-by="_id"
		:options="options"
		:show-labels="false"
		:hide-selected="true"
		:value="value"
		@select="onSelect"
		@search-change="onSearch">
		<template slot="beforeList">
			<div class="p-4" v-if="isFetching">
				<div class="is-loading dark"></div>
			</div>
		</template>
		<template slot="afterList">
			<div
				class="select-loadmore"
				@click="fetch(false)"
				v-if="hasNextPage">
				Load More
			</div>
		</template>
	</multiselect>
</template>

<script>
import { delay } from '@/lib/helper';
import productsApi from '@/api/products';

export default {
	name: 'ProductsSelect',
	props: {
		value: {
			type: Object,
		},
		getSlug: {
			type: Boolean,
			default: false,
		},
	},
	data() {
		return {
			options: [],
			page: 1,
			limit: 20,
			keyword: '',
			isFetching: false,
			hasNextPage: false,
		};
	},
	methods: {
		fetch(reset = false) {
			this.isFetching = true;
			if (reset) {
				this.page = 1;
				this.options = [];
			}
			const keyword = this.keyword.trim();
			const params = {
				page: this.page,
				limit: this.limit,
				sort_by: 'name',
				sort: 'asc',
			};
			if (this.supplierId != null) {
				params.user_id = this.supplierId;
			}
			if (keyword !== '') {
				params.keyword = keyword;
			}
			if (this.getSlug) {
				params.get_slug = this.getSlug;
			}
			const callback = (response) => {
				const products = response.data && response.data.products
					? response.data.products : response.data;
				this.hasNextPage = products.length === this.limit;
				this.appendOptions(products);
				this.page++;
				this.isFetching = false;
			};
			const errorCallback = () => {
				this.isFetching = false;
			};
			productsApi.getProducts(params, callback, errorCallback);
		},
		appendOptions(options) {
			for (let index = 0; index < options.length; index++) {
				const option = options[index];
				this.options.push(option);
			}
		},
		onSelect(selected) {
			this.$emit('input', selected);
		},
		reachedEndOfList(reached) {
			if (reached) {
				this.fetch();
			}
		},
		onSearch(keyword) {
			delay(() => {
				this.keyword = keyword;
				this.fetch(true);
			}, 500);
		},
	},
	created() {
		this.fetch();
	},
	computed: {
		supplierId() {
			return this.$route.query.supplier_id ?? null;
		},
	},
};
</script>
